import React from "react"
import "./styles/Card.css"

const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {

    return <div
        {...props}
        className={`AmoTools__Card ${props.className ?? ""}`}
    >
        { props.children }
    </div>

}

export default Card